import React, { useEffect, useState } from "react";
import { Download, Printer, Upload } from 'lucide-react';
import apiService from "../../../config";
import { useSignature } from '../../../DigitalSignature/UseSignatue';
import SignaturePad from '../../../DigitalSignature/SignaturePad';

const HighwayNoticeForm = ({ projectId = null }) => {

  const [data, setData] = useState([]);
  const [editMode, setEditMode] = useState(false); // Keep it as false to disable edit mode
  // const [editableData, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetching, setFetching] = useState(true);
  const [error, setError] = useState(null);
  const [locationInfo, setLocationInfo] = useState({});
  const [debugInfo, setDebugInfo] = useState(null);
  const [proposalNo, setProposalNo] = useState('');
  const [proposalData, setProposalData] = useState(null);
  const [regionalInchargeName, setRegionalInchargeName] = useState("");
  const [regionalInchargeDesignation, setRegionalInchargeDesignation] = useState("");
  const [InchargeName, setInchargeName] = useState("");
  const [InchargeDesignation, setInchargeDesignation] = useState("");
  const [signatureFile, setSignatureFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, '0')}/${String(today.getMonth() + 1).padStart(2, '0')}/${today.getFullYear()}`;
  const userData = JSON.parse(localStorage.getItem('userData'));
  const userRole = parseInt(userData?.data?.user_role || userData?.user_role, 10);
  const userName = userData?.full_name || 'N/A';
  const userDesi = userData?.designation || 'N/A';
  const [uploadStatus, setUploadStatus] = useState("idle");
  // "idle" | "uploading" | "success" | "error"
  const [uploadError, setUploadError] = useState("");
  const [showSignaturePad, setShowSignaturePad] = useState(false);
  const [pdfForSigning, setPdfForSigning] = useState(null);
  const { signDocument } = useSignature();

  // Helper function to find proposalId in the project object
  const findProposalId = (projectObj) => {
    if (!projectObj) return null;

    const possibleKeys = [
      'acquisition_proposal_no',
      'land_acquisition_no',
      'proposal_id',
      'proposalId',
      'proposal',
      'id',
      'project_id'
    ];

    for (const key of possibleKeys) {
      if (projectObj[key] !== undefined && projectObj[key] !== null && projectObj[key] !== '') {
        // console.log(`Found proposalId in key: ${key}, value: ${projectObj[key]}`);
        return projectObj[key];
      }
    }

    // console.log('Available keys in project object:', Object.keys(projectObj));
    // console.log('Project object values:', projectObj);
    return null;
  };

  const fetchLandHoldings = async () => {
    setFetching(true); // show loading state before fetch
    try {
      setLoading(true);
      setError(null);

      const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
      const projectIdFromStorage = selectedProject?.id || selectedProject?.project_id;
      const proposalId = localStorage.getItem('currentProposalId') || findProposalId(selectedProject);
      const currentProjectId = projectId || projectIdFromStorage;

      // Get acquisition_regional_incharge_name from selectedProposal
      // const storedProposal = JSON.parse(localStorage.getItem('selectedProposal') || '{}');
      // if (storedProposal?.acquisition_regional_incharge_name) {
      //   setRegionalInchargeName(storedProposal.acquisition_regional_incharge_name);
      // }
      // if (storedProposal?.acquisition_regional_incharge_designation) {
      //   setRegionalInchargeDesignation(storedProposal.acquisition_regional_incharge_designation);
      // }
      // if (storedProposal?.acquisition_incharge_designation) {
      //   setInchargeDesignation(storedProposal.acquisition_incharge_designation);
      // }
      // if (storedProposal?.acquisition_incharge_name) {
      //   setInchargeName(storedProposal.acquisition_incharge_name);
      // }

      if (!currentProjectId || !proposalId) {
        const missingParams = [];
        if (!currentProjectId) missingParams.push('projectId');
        if (!proposalId) missingParams.push('proposalId');

        setError(`Missing required parameters: ${missingParams.join(', ')}. Please select a project first.`);
        setLoading(false);
        return;
      }

      const storedLocationInfo = localStorage.getItem('selectedLocationInfo');
      // console.log("-------------------:",storedLocationInfo)
      let apiParams = {
        proposalId: proposalId
      };

      if (storedLocationInfo) {
        const locationData = JSON.parse(storedLocationInfo);
        apiParams = {
          ...apiParams,
          distNo: locationData.district,
          talukaNo: locationData.taluka,
          villageNo: locationData.village
        };
        setLocationInfo(locationData);
      }

      const result = await apiService.getLandHolding(currentProjectId, apiParams);

      console.log("Result", result);


      setDebugInfo({
        apiResponse: result,
        requestParams: { projectId: currentProjectId, ...apiParams },
        responseStatus: result?.status,
        responseData: result?.data,
        dataType: typeof result?.data,
        dataLength: result?.data?.length,
        dataKeys: result?.data ? Object.keys(result.data) : null,
        rawResponse: result,
        isEmptyString: result === "",
        isNull: result === null,
        isUndefined: result === undefined
      });

      if (!result || result === "" || result === null || result === undefined) {
        setError(`API returned invalid response: ${JSON.stringify(result)}. Check API endpoint and network connection.`);
        return;
      }

      let dataArray = null;
      let responseStatus = result?.status || result?.statusCode || 200;

      if (responseStatus === 200 || responseStatus === "200") {
        // FIXED: Extract proposalData first
        if (result?.proposalData && Array.isArray(result.proposalData) && result.proposalData.length > 0) {
          const proposal = result.proposalData[0];
          setProposalNo(proposal.acquisition_proposal_no);
          setProposalData(proposal);
          // ✅ DIRECT FROM API (MAIN REQUIREMENT)
          setRegionalInchargeName(
            proposal.acquisition_regional_incharge_name || ""
          );
          setRegionalInchargeDesignation(
            proposal.acquisition_regional_incharge_designation || ""
          );
          setInchargeName(
            proposal.acquisition_incharge_name || ""
          );
          setInchargeDesignation(
            proposal.acquisition_incharge_designation || ""
          );
          // console.log('📊 Extracted Proposal No:', proposalInfo.acquisition_proposal_no);
        }
        let dataArray = [];

        // Then extract land holdings data
        if (Array.isArray(result.data)) {
          dataArray = result.data;
        } else if (result.data && Array.isArray(result.data.data)) {
          dataArray = result.data.data;
        } else if (result.data && Array.isArray(result.data.items)) {
          dataArray = result.data.items;
        } else if (result.data && Array.isArray(result.data.records)) {
          dataArray = result.data.records;
        } else if (result.data && Array.isArray(result.data.landHoldings)) {
          dataArray = result.data.landHoldings;
        }

        if (dataArray && dataArray.length > 0) {
          const firstRecord = dataArray[0];
          if (!storedLocationInfo && firstRecord) {
            const extractedLocationInfo = {
              projectId: firstRecord.project_id || currentProjectId,
              district: firstRecord.dist_name,
              taluka: firstRecord.tehsil_name || firstRecord.taluka_name,
              village: firstRecord.village_name || firstRecord.VillageName,
              districtNo: firstRecord.dist_no,
              talukaNo: firstRecord.tehsil_no,
              villageNo: firstRecord.village_no
            };
            setLocationInfo(extractedLocationInfo);
            localStorage.setItem('selectedLocationInfo', JSON.stringify(extractedLocationInfo));
          }

          const transformedData = dataArray.map((item, index) => ({
            ...item,
            sr_no: index + 1
          }));

          setData(transformedData);

        } else {
          const errorMsg = result.data
            ? `API returned successful response but no data records found. Response structure: ${JSON.stringify(result.data, null, 2)}`
            : 'API returned empty response';
          setError(errorMsg);
        }
      } else {
        setError(`API returned status ${responseStatus}: ${result?.message || result?.error || 'Unknown error'}. Raw response: ${JSON.stringify(result)}`);
      }
    } catch (err) {
      console.error('❌ Error fetching land holdings:', err);
      setError(`Failed to fetch land holdings data: ${err.message}`);
      setDebugInfo({
        error: err,
        errorMessage: err.message,
        errorStack: err.stack
      });
    } finally {
      setLoading(false);
    }
  };


  // useEffect to fetch land holding list
  useEffect(() => {
    if (!previewUrl) {
      fetchLandHoldings();
    }
  }, [projectId]);

  const handleChange = (index, key, value) => {
    const updated = [...data];
    updated[index][key] = value;
    setData(updated);
  };

  const handlePrint = () => {
    // Add this loading check at the start
    if (loading) {
      alert("Data is still loading. Please wait before printing.");
      return;
    }

    // Fallback: Print HTML if previewUrl not available
    if (!data || data.length === 0) {
      alert("No data to print yet.");
      return;
    }

    const wasEditing = editMode;
    setEditMode(false);

    setTimeout(() => {
      const printContent = document.getElementById("notice-content")?.innerHTML;

      if (!printContent || printContent.trim() === "") {
        alert("Print content is empty.");
        setEditMode(wasEditing);
        return;
      }

      const win = window.open("", "", "height=900,width=1200");
      win.document.write(`
      <html>
      <head>
        <meta charset="UTF-8">
        <title>क्षेत्राची यादी अहवाल -दुरुस्ती</title>
        <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;600;700&display=swap" rel="stylesheet">
        <style>
          @page {
            size: A4 portrait;
            margin-top: 0.19in;
            margin-bottom: 0.25in;
            margin-left: 0.81in;
            margin-right: 0.5in;
          }
          
          body {
            font-family: 'DVOT-Surekh', 'Mangal', 'Arial', sans-serif;
            font-size: 12pt;
            line-height: 1.4;
          }
          
          * {
            box-sizing: border-box;
          }
          
          /* Table styles */
          table {
            border-collapse: collapse;
            width: 100%;
            margin-top: 10px;
            margin-bottom: 1rem;
            page-break-inside: auto !important;
            font-size: 10pt;
          }
          
          thead {
            display: table-header-group;
          }
          
          tr {
            page-break-inside: avoid;
            page-break-after: auto;
          }
          
          th, td {
            border: 1px solid black;
            padding: 4px;
            text-align: center;
            font-size: 9pt;
            vertical-align: middle;
            page-break-inside: avoid;
          }
          
          th {
            background-color: #f9fafb;
            font-weight: bold;
            font-size: 10pt;
          }
          
          /* Headings */
          h1, h2, h3, h4, h5, h6 {
            margin: 1rem 0 0.5rem 0;
            page-break-after: avoid;
            font-weight: bold;
          }
          
          h2 {
            font-size: 16pt;
            text-align: center;
            margin-top: 1rem;
            margin-bottom: 1rem;
            font-family: 'DVOT-Surekh', 'Mangal', sans-serif;
          }
          
          h3 {
            text-align: center;
            margin: 0;
            font-size: 14pt;
          }
          
          /* Paragraphs */
          p {
            margin: 0.5rem 0;
            line-height: 1.6;
            orphans: 3;
            widows: 3;
            font-size: 11pt;
          }
          
          /* Text utilities */
          .text-center {
            text-align: center;
          }
          
          .center-text {
            text-align: center;
          }
          
          .left-text {
            text-align: left;
          }
          
          .text-right {
            text-align: right;
          }
          
          .text-base {
            font-size: 11pt;
          }
          
          .text-sm {
            font-size: 10pt;
          }
          
          .text-xs {
            font-size: 9pt;
          }
          
          .text-lg {
            font-size: 1.125rem;
          }
          
          .text-xl {
            font-size: 1.5rem;
          }
          
          .text-2xl {
            font-size: 1.8rem;
          }
          
          /* Font weights */
          .font-bold {
            font-weight: bold;
          }
          
          .font-semibold {
            font-weight: 600;
          }
          
          .font-medium {
            font-weight: 500;
          }
          
          /* Margins */
          .mb-1 {
            margin-bottom: 0.25rem;
          }
          
          .mb-2 {
            margin-bottom: 0.5rem;
          }
          
          .mb-4 {
            margin-bottom: 1rem;
          }
          
          .mb-6 {
            margin-bottom: 1.5rem;
          }
          
          .mt-1 {
            margin-top: 0.25rem;
          }
          
          .mt-2 {
            margin-top: 0.5rem;
          }
          
          .mt-4 {
            margin-top: 1rem;
          }
          
          .mt-6 {
            margin-top: 1.5rem;
          }
          
          .mt-8 {
            margin-top: 2rem;
          }
          
          .mt-10 {
            margin-top: 2rem;
          }
          
          /* Padding */
          .p-2 {
            padding: 0.5rem;
          }
          
          .p-3 {
            padding: 0.75rem;
          }
          
          .p-4 {
            padding: 1rem;
          }
          
          /* Borders */
          .border {
            border: 1px solid black;
          }
          
          .border-2 {
            border: 2px solid black;
          }
          
          .border-black {
            border-color: black;
          }
          
          /* Alignment */
          .align-center {
            text-align: center;
          }
          
          /* Layout */
          .flex {
            display: flex;
          }
          
          .justify-between {
            justify-content: space-between;
          }
          
          .justify-center {
            justify-content: center;
          }
          
          .items-center {
            align-items: center;
          }
          
          /* Spacing utilities */
          .space-y-4 > * + * {
            margin-top: 1rem;
          }
          
          .mx-auto {
            margin-left: auto;
            margin-right: auto;
          }
          
          /* Other utilities */
          .underline {
            text-decoration: underline;
          }
          
          .indent-8 {
            text-indent: 2rem;
          }
          
          br {
            line-height: 1.2;
          }

          /* Signature section styles - ADD THIS */
.signature-section {
  display: flex;
  justify-content: space-between;
  margin-top: 100px;
  page-break-inside: avoid;
  padding: 0 40px;
}

.signature-block {
  text-align: center;
  min-width: 250px;
}

.signature-name {
  margin-bottom: 12px;
  font-weight: 600;
  font-size: 11pt;
}

.signature-designation {
  font-size: 10pt;
}

@media print {
  .signature-section {
    page-break-inside: avoid;
    break-inside: avoid;
  }
}
          
          /* Print specific */
          @media print {
            body {
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            
            .page-break {
              page-break-after: always;
            }
            
            table {
              page-break-inside: auto !important;
              font-size: 10px;
            }
            
            thead {
              display: table-header-group;
            }
            
            tfoot {
              display: table-footer-group;
            }
            
            tr {
              page-break-inside: avoid;
              page-break-after: auto;
            }
            
            th, td {
              page-break-inside: avoid;
              page-break-after: auto;
              padding: 2px;
            }
            
            .page-break-avoid {
              page-break-inside: avoid;
              break-inside: avoid;
            }
            
            .no-print {
              display: none !important;
            }
          }
        </style>
      </head>
      <body>
        ${printContent}
      </body>
      </html>
    `);
      win.document.close();
      win.print();

      setEditMode(wasEditing);
    }, 200);
  };

  const handleUploadedFile = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    // ✅ open uploaded file in signature modal
    setPdfForSigning(file);
    setShowSignaturePad(true);
  };

  const handleDownloadWord = () => {
    if (previewUrl) {
      // 🔹 Open same file in new tab but force .doc download
      const link = document.createElement("a");
      link.href = previewUrl;
      link.target = "_blank";
      link.download = "अनुसूची-२.doc";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return;
    }

    // ⏬ Fallback: Generate Word from HTML if no previewUrl
    if (loading) {
      alert("Data is still loading. Please wait before downloading.");
      return;
    }

    const wasEditing = editMode;
    setEditMode(false);

    setTimeout(() => {
      const content = document.getElementById("notice-content").innerHTML;

      const header = `
      <html xmlns:o='urn:schemas-microsoft-com:office:office' 
            xmlns:w='urn:schemas-microsoft-com:office:word' 
            xmlns='http://www.w3.org/TR/REC-html40'>
      <head><title>अनुसूची-२</title>
      <style>
        body { font-family: 'Mangal', 'Arial', sans-serif; margin: 20mm; }
        table { border-collapse: collapse; width: 100%; margin-top: 10px; }
        th, td { border: 1px solid black; padding: 4px; text-align: center; }
        h2, h3 { text-align: center; margin: 0; }
        .center-text { text-align: center; }
        .left-text { text-align: left; }
      </style>
      </head><body>`;

      const footer = "</body></html>";
      const sourceHTML = header + content + footer;

      const blob = new Blob(['\ufeff', sourceHTML], {
        type: 'application/msword',
      });

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `जमीन संपादन अहवाल.doc`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      setEditMode(wasEditing);
    }, 200);
  };

  const surveyTypes = ["सर्व्हे क्रमांक", "गट क्रमांक", "प्लॉट क्रमांक"];

  const surveyKramankData = data.filter(
    item => surveyTypes.includes(item.survey_type)
  );


  const gharKramankData = data.filter(
    item => item.survey_type === "घर क्रमांक."
  );



  // if (!isOpen) return null;

  return (
    <div className="max-w-6xl mx-auto p-6 bg-white">
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center space-x-3">
          <button
            onClick={handlePrint}
            className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            <Printer size={18} />
            <span>Print</span>
          </button>
          <button
            onClick={handleDownloadWord}
            className="flex items-center space-x-2 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:opacity-50"
          >
            <Download size={18} />
            <span>Download Word</span>
          </button>
          <button className="relative">
            <label className="flex items-center space-x-2 px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 cursor-pointer">
              <Upload size={18} />
              <span>Upload Signature</span>
              <input
                type="file"
                accept="application/pdf,image/*"
                className="hidden"
                onChange={handleUploadedFile}
              />
            </label>
          </button>

        </div>
      </div>
      {previewUrl ? (
        // 🔹 Show PDF directly if signed file exists
        <div className="w-full bg-white p-4 rounded-lg">
          <iframe
            src={`${previewUrl}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
            // src={`${previewUrl}`}
            title="Anusuchi-2 PDF"
            width="100%"
            height="800px"
            style={{
              border: "none",
              borderRadius: "8px",
              boxShadow: "none",
              outline: "none",
              margin: "0",
              padding: "0"
            }}
            frameBorder="0"
            seamless
          />
        </div>
      ) : (
        <>


          {/* Header */}
          <div className="text-center mb-6">
            <div id="notice-content" style={{ margin: "10mm" }}>
              {loading ? (
                <div className="flex justify-center items-center h-96">
                  <p className="text-lg text-gray-600">Loading...</p>
                </div>
              ) : (
                <>
                  {/* <h3 className="center-text">जमीन संपादन अहवाल</h3> */}
                  <div className="text-center mb-6">
                    <div className=" p-4 mb-4">
                      <h2 className="text-lg font-bold mb-2 align-center ">
                        प्रकल्प नाव: {data.projectName || proposalData?.project_name}
                      </h2>
                      <h2 className="text-base font-semibold mb-2">
                        प्रस्ताव नाव: {proposalNo}
                      </h2>
                      {data.length > 0 && (
                        <h2 className="text-base font-semibold mb-2">
                          गाव: {data[0].village_name} , तालुका: {data[0].taluka_name} , जिल्हा: {data[0].dist_name}
                        </h2>
                      )}
                    </div> </div>
                  {surveyKramankData.length > 0 && (
                    <table style={{ borderCollapse: "collapse", width: "100%", border: "1px solid black" }}>
                      <thead>
                        <tr>
                          <th style={{ border: "1px solid black", padding: "8px" }}>अ.क्र.</th>
                          <th style={{ border: "1px solid black", padding: "8px" }}>गट/सर्व्हे  क्रमांक</th>
                          <th style={{ border: "1px solid black", padding: "8px", minWidth: "200px" }}>
                            भूधारकाचे नाव
                          </th>
                          <th className="border border-black p-3 text-center font-bold" colSpan="3">
                            भूसंपादनासाठी प्रस्तावित क्षेत्र ({surveyKramankData[0].unit_name})
                          </th>
                        </tr>
                        <tr className="bg-gray-50">
                          <th className="border border-black p-2"></th>
                          <th className="border border-black p-2"></th>
                          <th className="border border-black p-2"></th>
                          <th className="border border-black p-2 text-center text-sm">
                            लागवड योग्य क्षेत्र
                          </th>
                          <th className="border border-black p-2 text-center text-sm">
                            पोट खराब क्षेत्र
                          </th>
                          <th className="border border-black p-2 text-center text-sm">
                            एकूण
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {[...surveyKramankData]
                          .sort((a, b) => a.LandAcquisition_id - b.LandAcquisition_id)
                          .map((item, idx) => {
                            const hasOwners = item.owners && item.owners.length > 0;
                            const rowSpanValue = hasOwners ? item.owners.length : 1;

                            return hasOwners ? (
                              <React.Fragment key={idx}>
                                {item.owners.map((owner, ownerIdx) => (
                                  <tr key={`${idx}-owner-${ownerIdx}`}>
                                    {ownerIdx === 0 && (
                                      <td rowSpan={rowSpanValue} style={{ border: "1px solid black", padding: "8px", textAlign: "center" }}>
                                        {idx + 1}
                                      </td>
                                    )}
                                    {ownerIdx === 0 && (
                                      <td rowSpan={rowSpanValue} style={{ border: "1px solid black", padding: "8px", textAlign: "center" }}>
                                        {item.survey_no}
                                      </td>
                                    )}
                                    <td style={{ border: "1px solid black", padding: "8px", whiteSpace: "pre-line", textAlign: "center" }}>
                                      {owner.owner_name
                                        ?.split(",")
                                        .map((name, i, arr) =>
                                          i < arr.length - 1 ? name.trim() + "," : name.trim()
                                        )
                                        .join("\n")}
                                    </td>
                                    <td className="border border-black p-3 text-center font-mono">
                                      {parseFloat(owner.owner_irrigable_area || 0).toFixed(2)}
                                    </td>
                                    <td className="border border-black p-3 text-center font-mono">
                                      {parseFloat(owner.owner_non_irrigable_area || 0).toFixed(2)}
                                    </td>
                                    <td className="border border-black p-3 text-center font-mono font-bold">
                                      {(
                                        (Number(owner.owner_irrigable_area) || 0) +
                                        (Number(owner.owner_non_irrigable_area) || 0)
                                      ).toFixed(2)}
                                    </td>
                                  </tr>
                                ))}
                              </React.Fragment>
                            ) : null;
                          })}
                      </tbody>
                    </table>
                  )}

                  {gharKramankData.length > 0 && (
                    <table className="mt-8" style={{ borderCollapse: "collapse", width: "100%", border: "1px solid black" }}>
                      <thead>
                        <tr>
                          <th style={{ border: "1px solid black", padding: "8px" }}>अ.क्र.</th>
                          <th style={{ border: "1px solid black", padding: "8px" }}>घर क्रमांक</th>
                          <th style={{ border: "1px solid black", padding: "8px", minWidth: "200px" }}>
                            घर मालकाचे नाव
                          </th>
                          <th className="border border-black p-3 text-center font-bold" colSpan="3">
                            भूसंपादनासाठी प्रस्तावित क्षेत्र (चौरस फूट)
                          </th>
                        </tr>
                        <tr className="bg-gray-50">
                          <th className="border border-black p-2"></th>
                          <th className="border border-black p-2"></th>
                          <th className="border border-black p-2"></th>
                          <th className="border border-black p-2 text-center text-sm">
                            बांधकाम क्षेत्र
                          </th>
                          <th className="border border-black p-2 text-center text-sm">
                            संपादित क्षेत्र
                          </th>
                          <th className="border border-black p-2 text-center text-sm">
                            घराचे एकूण क्षेत्र
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {[...gharKramankData]
                          .sort((a, b) => a.LandAcquisition_id - b.LandAcquisition_id)
                          .map((item, idx) => {
                            const hasOwners = item.owners && item.owners.length > 0;
                            const rowSpanValue = hasOwners ? item.owners.length : 1;

                            return hasOwners ? (
                              <React.Fragment key={idx}>
                                {item.owners.map((owner, ownerIdx) => (
                                  <tr key={`${idx}-owner-${ownerIdx}`}>
                                    {ownerIdx === 0 && (
                                      <td rowSpan={rowSpanValue} style={{ border: "1px solid black", padding: "8px", textAlign: "center" }}>
                                        {idx + 1}
                                      </td>
                                    )}
                                    {ownerIdx === 0 && (
                                      <td rowSpan={rowSpanValue} style={{ border: "1px solid black", padding: "8px", textAlign: "center" }}>
                                        {item.survey_no}
                                      </td>
                                    )}
                                    <td style={{ border: "1px solid black", padding: "8px", whiteSpace: "pre-line", textAlign: "center" }}>
                                      {owner.owner_name
                                        ?.split(",")
                                        .map((name, i, arr) =>
                                          i < arr.length - 1 ? name.trim() + "," : name.trim()
                                        )
                                        .join("\n")}
                                    </td>
                                    <td className="border border-black p-3 text-center font-mono">
                                      {parseFloat(item.construction_area || 0).toFixed(2)}
                                    </td>
                                    <td className="border border-black p-3 text-center font-mono">
                                      {parseFloat(owner.owner_aqr_area || 0).toFixed(2)}
                                    </td>
                                    <td className="border border-black p-3 text-center font-mono font-bold">
                                      {(
                                        (Number(item.construction_area) || 0) +
                                        (Number(owner.owner_aqr_area) || 0)
                                      ).toFixed(2)}
                                    </td>
                                  </tr>
                                ))}
                              </React.Fragment>
                            ) : null;
                          })}
                      </tbody>
                    </table>
                  )}



                  {/* Signature Section  */}
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: '100px',
                    pageBreakInside: 'avoid',
                    padding: '0 40px'
                  }}>
                    <div style={{ textAlign: 'center' }}>
                      <div style={{ marginBottom: '12px', fontWeight: '600' }}>
                        ({regionalInchargeName || 'N/A'})
                      </div>
                      <div>{regionalInchargeDesignation || 'N/A'}</div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <div style={{ marginBottom: '8px', fontWeight: '600' }}>
                        ({InchargeName || 'N/A'})
                      </div>
                      <div>{InchargeDesignation || 'N/A'}</div>
                    </div>
                  </div>

                  <p
                    style={{
                      textAlign: "center",
                      marginTop: "20px",
                      fontSize: "small",
                    }}
                  ></p>
                </>
              )}
            </div>
          </div>
        </>
      )}

      {showSignaturePad && pdfForSigning && (
        <SignaturePad
          pdfFile={pdfForSigning}
          onSign={(signaturesArray) => {
            setShowSignaturePad(false);

            signDocument(pdfForSigning, signaturesArray).then(async (signedPdf) => {
              const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
              const projectId = selectedProject?.id || selectedProject?.project_id;
              const proposalId = localStorage.getItem("currentProposalId");

              await apiService.postAddSignaturePDF(
                projectId,
                proposalId,
                "parishisht1",
                signedPdf
              );

              const sectionRes = await apiService.getSectionFile(
                projectId,
                proposalId,
                "parishisht1"
              );

              if (sectionRes?.isSignAvailable) {
                setPreviewUrl(sectionRes.data[0].file_path);
              }

              setPdfForSigning(null);
            });
          }}
          onCancel={() => {
            setShowSignaturePad(false);
            setPdfForSigning(null);
          }}
        />
      )}
    </div>
  );
};

export default HighwayNoticeForm;